import { useTranslation } from '@/utils/hook'
import { Libre_Baskerville } from 'next/font/google'
import {
  Section,
  SectionContainer,
  SectionDescription,
  SectionTitle
} from '@/components/ui'

const libreBaskerville = Libre_Baskerville({
  subsets: ['latin'],
  weight: ['700'],
  display: 'swap',
  fallback: ['Georgia', 'Times New Roman', 'serif']
})

export function Cta(): JSX.Element {
  const t = useTranslation()

  return (
    <Section>
      <SectionContainer>
        <div className="flex flex-col items-center text-center">
          <div>
            <SectionTitle
              as="h2"
              size="hero"
              className={`${libreBaskerville.className} mx-auto mb-8 max-w-2xl`}
              style={libreBaskerville.style}
            >
              {t('product.ctaHeading')}
            </SectionTitle>
            <SectionDescription className="max-w-3xl mx-auto text-xl leading-tight tracking-wide">
              {t('product.ctaSubheading')}
            </SectionDescription>
          </div>

          <div className="mt-10 flex">
            <a
              href="https://my.heyform.net/sign-up"
              className="inline-flex items-center justify-center rounded-full bg-slate-950 px-5 py-3 text-base font-medium text-white shadow-[0_8px_24px_rgba(15,23,42,0.18)] transition-transform duration-200 hover:bg-slate-700 md:text-lg"
            >
              {t('common.tryFree')}
            </a>
          </div>
        </div>
      </SectionContainer>
    </Section>
  )
}
